"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.exerciseGoal = exports.getSummaryResults = exports.questions = void 0;

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

var questions = [{
  prompt: "Here are a list of common metacognitions. Choose one of them or write your own one.",
  type: "multiWithOther",
  meta: {
    answerLabel: "My metacognitions are",
    summaryTitle: "Your metacognition was about:"
  },
  options: ["Worrying helps me to avoid problems in the future", "If I don’t focus on what worries me and it happens, then the consequences would be my fault", "I need to worry so that I can stay organised", "It’s bad to think certain thoughts. I have to stay in control of them.", "If I can’t stay in control of my thoughts I wouldn’t be able to function", "Other"],
  batteryId: "RETRAINING_THINKING_METACOGNITION"
}, {
  prompt: "Next we look for the payoffs from using your metacognition. I understand that there might be costs, and we will look at these next. For now, can you finish this sentence: It’s important to keep thinking in this way because…",
  type: "multiWithOther",
  meta: {
    answerLabel: "My payoffs are",
    summaryTitle: "The payoffs from your metacognition were:"
  },
  options: ["It helps me to work well", "Not being in control of thoughts is a sign of weakness", "Worrying helps me to solve problems", "I have a bad memory so worry helps me to cope", "It’s wrong not to control bad thoughts", "Other"],
  batteryId: "RETRAINING_THINKING_METACOGNITION"
}, {
  prompt: "Now let’s look at the disadvantages. The cost is thinking like this is…",
  type: "multiWithOther",
  meta: {
    answerLabel: "The costs are",
    summaryTitle: "The costs of your metacognition were:"
  },
  options: ["I feel like I’m going crazy with worrying", "Worries can get so out of control that I stop functioning well", "I feel abnormal from all the worry I do", "I’m losing out in life because of all the worry I do", "My body can’t take all the constant worrying", "Other"],
  batteryId: "RETRAINING_THINKING_METACOGNITION"
}, {
  prompt: "Metacognitions keep us focused on our worries. If you feel ready to shift from an internal focus to an external focus then think of someone who was kind to you like…",
  type: "multiWithOther",
  meta: {
    answerLabel: "My external focus are",
    summaryTitle: "Your external focus are:"
  },
  options: ["A grandparent", "A teacher", "A parent", "A friend", "A partner", "A mentor", "A therapist", "Other"],
  batteryId: "RETRAINING_THINKING_METACOGNITION"
}];
exports.questions = questions;
var exerciseGoal = "The goal was to help you identify the metacognition that drives repeated worrying. We recommend shifting your attention from your internal world to the external world whenever you notice worrying.";
exports.exerciseGoal = exerciseGoal;

var getSummaryResults = function getSummaryResults(answers) {
  return questions.map(function (question, index) {
    if (!question.hideFromSummary && answers[question.batteryId][index]) {
      if (question.type === "radio") {
        return {
          question: question,
          answer: question.options[answers[question.batteryId][index]]
        };
      } else {
        return {
          question: question,
          answer: answers[question.batteryId][index]
        };
      }
    }
  }).filter(function (item) {
    return _typeof(item) === "object";
  });
};

exports.getSummaryResults = getSummaryResults;